import {getBearerTokenCookie} from "@/lib/cookies";

export function headers() {
    const token = getBearerTokenCookie();

    if (token == null) {
        return {
            "x-ltg-app-version": `${window.appConfig.appVersion}`,
        };
    }

    return {
        Authorization: `Bearer ${token}`,
        "x-ltg-app-version": `${window.appConfig.appVersion}`,
    };
}
